import React from 'react';
import { Resizable, ResizeCallback } from 're-resizable';
import cn from 'classnames';

import { useWidgetContext } from 'widget/widget-context';
import { withActive } from 'widget/hoc/with-active';
import * as Env from 'widget/env';

import { useResize } from './hooks';
import ChatBody from './chat-body/chat-body';
import ChatHead from './chat-head/chat-head';

interface Chat {
  isActive: boolean;
  maxSize: Env.MaxSize;
}

const Chat = ({ isActive, maxSize }: Chat) => {
  const { widget } = useWidgetContext();
  const { defaultSize, size, updateSize } = useResize();

  const handleResizeStop: ResizeCallback = (event, direction, elementRef) =>
    updateSize({
      height: elementRef.clientHeight,
      width: elementRef.clientWidth,
    });

  return (
    <Resizable
      {...maxSize}
      className={cn('whatcrm-widget-chat', {
        'whatcrm-widget-chat_active': isActive,
        [`whatcrm-widget-chat_${widget.chat_type}`]: widget.chat_type,
      })}
      defaultSize={size || defaultSize}
      minHeight={426}
      minWidth={240}
      onResizeStop={handleResizeStop}
      size={size}
      style={{ position: 'absolute' }}
    >
      <ChatHead size={size} updateSize={updateSize} />
      <ChatBody isChatActive={isActive} />
    </Resizable>
  );
};

const withActiveChat = withActive(Chat);
export default withActiveChat;
